import {combineReducers} from "@reduxjs/toolkit";

import {astrologerReducer} from "../modules/user/astrologer/redux/astrologer.slice";

export const rootReducer = combineReducers({
  astrologerReducer,
});
